import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteAssessmentRequest = createAction('deleteAssessmentRequest');
export const deleteAssessmentSuccess = createAction<{ assessmentID: number }>(
    'deleteAssessmentSuccess',
);
export const deleteAssessmentFailure = createAction('deleteAssessmentFailure');

export const deleteAssessment = (assessmentID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(deleteAssessmentRequest());
    try {
        await api.delete(`admin/assessments/${assessmentID}`);
        dispatch(deleteAssessmentSuccess({ assessmentID }));
    } catch (e) {
        handleApiErrors(dispatch, deleteAssessmentFailure, e as any);
    }
};
